import React from "react";
import { Link } from "react-router-dom";
import { useForm } from "react-hook-form";
import useCart from "./../../../hooks/useCart";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { hasImage } from "../../Products/components/ProductItem";
import { formatCurrency } from "../../../util/formatters";

const validationSchema = yup.object().shape({
  quantity: yup.number().min(0).integer(),
});

const CartTableItem = (props) => {
  const { dispatch, cart } = useCart();

  const { register, handleSubmit } = useForm({
    defaultValues: { quantity: props.obj.quantity },
    resolver: yupResolver(validationSchema),
  });

  // Busca o item atualizado do carrinho para garantir que temos a quantidade mais recente
  const currentItem = cart.find((item) => item.product_id === props.obj.product_id) || props.obj;
  const displayQuantity = currentItem.quantity;

  const changeCartItemQuantity = (value) => {
    if (value === 0) {
      dispatch({
        type: "DELETE",
        obj: props.obj,
      });
    } else {
      dispatch({
        type: "CHANGE_QUANTITY",
        obj: props.obj,
        quantity: value,
      });
    }
  };
  
  const onSubmit = (data) => {
    changeCartItemQuantity(data.quantity);
  };

  const handleBlur = (e) => {
    e.preventDefault();
    const value = parseInt(e.target.value) || 0;
    changeCartItemQuantity(value);
  };


  return (
    <tr>
      <td className="px-5 cart-product-image text-center">
        <Link
          to={`/produto/${props.obj.id}`}
          title={props.obj.product_name ? `Ver produto — ${props.obj.product_name}` : "Ver produto"}
        >
          <img
            src={hasImage(props.obj.image)}
            alt={props.obj.product_name ? `${props.obj.product_name} - ${props.obj.product_id}` : "Imagem do produto"}
            style={{ height: "90px" }}
            loading="lazy"
          />
        </Link>
      </td>
      <td className="px-5 cart-product-info">
        <h4 className="ltn__secondary-color">
          <Link
            to={`/produto/${props.obj.id}`}
            title={props.obj.product_name ? `Ver produto — ${props.obj.product_name}` : "Ver produto"}
          >
            {props.obj.product_name}
          </Link>
        </h4>
        <p>{props.obj.description}</p>
      </td>
      <td className="px-5 cart-product-price text-center">
        {formatCurrency(props.obj.price)}
      </td>
      <td className="px-5 cart-product-subtotal ">
        <div className="text-center row h-100 align-content-center ">
          <form 
            onSubmit={(e) => {
              e.preventDefault();
              handleSubmit(onSubmit)(e);
            }}
          >
            <i
              className="fa-solid fa-circle-info"
              title="Você pode mudar a quantidade de items de cada produto."
            ></i>
            <input
              type="number"
              {...register("quantity")}
              onBlur={handleBlur}
              className="cart-plus-minus-box border mx-1"
            />
          </form>
        </div>
      </td>
      <td className="px-5 cart-product-total text-center">
        {formatCurrency(displayQuantity * props.obj.price)}
      </td>
    </tr>
  );
};
export default CartTableItem;
